import { Box, Button, Flex, Stack, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'

import CarouselSlides from '@/components/Swiper/CarouselSlides'

import styles from './styles.module.css'

export default function CardsContainer<T>({
  title,
  description,
  data,
  link,
  render,
}: {
  title: string
  description: string
  data: T[]
  link: string
  render: (item: T, idx: number) => React.ReactNode
}) {
  const t = useTranslations('cardsContainer')

  return (
    <Box>
      <Flex justify="space-between" align="flex-end" w="100%" mb={24}>
        <Stack maw="calc(90% - 80px)" gap={0}>
          <Text variant="heading1">{title}</Text>
          <Text variant="heading3" c="var(--text-secondary)">
            {description}
          </Text>
        </Stack>
        <Button className={styles.button} onClick={() => window.open(link, '_blank')}>
          <Text variant="body-emphasis" c="#92D1FF">
            {t('viewAll')}
          </Text>
        </Button>
      </Flex>

      <CarouselSlides
        swiperList={data}
        renderSwiper={render}
        onSlideChange={() => {}}
        getEmblaApi={() => {}}
      />
    </Box>
  )
}
